import { render, staticRenderFns } from "./HomeNoticeSwiperCard.vue?vue&type=template&id=19b6eddc&scoped=true&"
import script from "./HomeNoticeSwiperCard.vue?vue&type=script&lang=js&"
export * from "./HomeNoticeSwiperCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeNoticeSwiperCard.vue?vue&type=style&index=0&id=19b6eddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6eddc",
  null
  
)

export default component.exports